export default "__VITE_ASSET__o1a379Mu__"